import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=678248c4&scoped=true"
import script from "./InfoDialog.vue?vue&type=script&lang=js"
export * from "./InfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678248c4",
  null
  
)

export default component.exports